import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

const customConfig = defineConfig({
  theme: {
    recipes: {
      button: {
        defaultVariants: {
          variant: 'solid',
        } as Record<string, string>,
      },
    },
  },
});

export const system = createSystem(defaultConfig, customConfig, {
  theme: {
    keyframes: {
      navItemIn: {
        from: { opacity: 0, transform: 'translateX(-8px)' },
        to: { opacity: 1, transform: 'translateX(0)' },
      },
      newBadgePulse: {
        '0%, 100%': { boxShadow: '0 0 0 0 rgba(250, 204, 21, 0.55)' },
        '70%': { boxShadow: '0 0 0 5px rgba(250, 204, 21, 0)' },
      },
    },
    tokens: {
      colors: {
        brand: {
          50: { value: '#e0f6ff' },
          100: { value: '#bbdff5' },
          200: { value: '#94c8e9' },
          300: { value: '#6cb1df' },
          400: { value: '#459bd5' },
          500: { value: '#00509d' },
          600: { value: '#206593' },
          700: { value: '#14486a' },
          800: { value: '#052b42' },
          900: { value: '#000f1b' },
        },
        primary: {
          50: { value: '#e0f6ff' },
          100: { value: '#bbdff5' },
          200: { value: '#94c8e9' },
          300: { value: '#6cb1df' },
          400: { value: '#459bd5' },
          500: { value: '#00509d' },
          600: { value: '#206593' },
          700: { value: '#14486a' },
          800: { value: '#052b42' },
          900: { value: '#000f1b' },
          950: { value: '#000a12' },
        },
        secondary: {
          50: { value: '#f8fafc' },
          100: { value: '#f1f5f9' },
          200: { value: '#e2e8f0' },
          300: { value: '#cbd5e1' },
          400: { value: '#94a3b8' },
          500: { value: '#64748b' },
          600: { value: '#475569' },
          700: { value: '#334155' },
          800: { value: '#1e293b' },
          900: { value: '#0f172a' },
          950: { value: '#020617' },
        },
        blue: {
          50: { value: '#f5fcff' },
        },
        gray: {
          100: { value: '#f7fafc' },
        },
      },
    },
    semanticTokens: {
      colors: {
        message: {
          bubble: {
            bg: { value: '{colors.gray.100}' },
            fg: { value: '{colors.secondary.800}' },
            ownBg: { value: '{colors.brand.subtle}' },
          },
          mention: {
            bg: { value: '{colors.brand.subtle}' },
            fg: { value: '{colors.brand.fg}' },
          },
          systemAccent: { value: '{colors.secondary.400}' },
          unfurl: {
            border: { value: '{colors.secondary.200}' },
          },
        },
        brand: {
          solid: { value: '{colors.brand.500}' },
          contrast: { value: 'white' },
          fg: { value: '{colors.brand.700}' },
          muted: { value: '{colors.brand.200}' },
          subtle: { value: '{colors.brand.50}' },
          emphasized: { value: '{colors.brand.300}' },
          focusRing: { value: '{colors.brand.500}' },
          border: { value: '{colors.brand.200}' },
        },
        primary: {
          solid: { value: '{colors.primary.500}' },
          contrast: { value: 'white' },
          fg: { value: '{colors.primary.700}' },
          muted: { value: '{colors.primary.200}' },
          subtle: { value: '{colors.primary.50}' },
          emphasized: { value: '{colors.primary.300}' },
          focusRing: { value: '{colors.primary.500}' },
          border: { value: '{colors.primary.200}' },
        },
        secondary: {
          solid: { value: '{colors.secondary.500}' },
          contrast: { value: 'white' },
          fg: { value: '{colors.secondary.700}' },
          muted: { value: '{colors.secondary.200}' },
          subtle: { value: '{colors.secondary.50}' },
          emphasized: { value: '{colors.secondary.300}' },
          focusRing: { value: '{colors.secondary.500}' },
          border: { value: '{colors.secondary.200}' },
        },
      },
    },
  },
  globalCss: {
    '.chakra-icon': {
      width: '1em',
      height: '1em',
    },
    '.chakra-field__root': {
      alignItems: 'stretch !important',
    },
    '.zsiq_theme1.zsiq_floatmain': {
      base: {
        left: '-200px !important',
      },
      lg: {
        right: '10px !important',
        left: 'auto !important',
      },
    },
  },
});
